import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/usr/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import SharedPopUp from "@componentsShared/SharedPopUp/SharedPopUp";
import { CDN_LINK } from "@globalConfig";
import validate from "./validate";
import stl from "./ContactForm.module.css";
import { onPushDataLayerNew } from "@/utils/events";
import { useTranslation } from "@i18n";
import InputPhoneNumber from "@componentsShared/InputPhoneNumber/InputPhoneNumber";
import { api__contactUsSubmit } from "@/apis/contact/contact-us";
import toast from "react-hot-toast";
import { ValidationException } from "@/common/exceptions/ValidationException";
import useButtonLoading from "@hooks/useButtonLoading";
import useWebviewInputFieldFocusBehavior from "@hooks/useWebviewInputFieldFocusBehavior";
var ContactForm = function ContactForm() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var buttonLoading = useButtonLoading();
  useWebviewInputFieldFocusBehavior(150);
  var _useState = useState({
      name: "",
      phone: "",
      email: "",
      subject: "",
      body: ""
    }),
    values = _useState[0],
    setValues = _useState[1];
  var _useState2 = useState({
      name: "",
      phone: "",
      email: "",
      subject: "",
      body: ""
    }),
    errors = _useState2[0],
    setErrors = _useState2[1];
  var _useState3 = useState({
      name: false,
      phone: false,
      email: false,
      subject: false,
      body: false
    }),
    isCorrect = _useState3[0],
    setIsCorrect = _useState3[1];
  var _useState4 = useState(false),
    msPopUp = _useState4[0],
    setMsPopUp = _useState4[1];
  var handleChange = function handleChange(e) {
    var _e$target = e.target,
      name = _e$target.name,
      value = _e$target.value;
    var errors = validate(t)(null, name, value);
    setValues(function (pre) {
      return _objectSpread(_objectSpread({}, pre), {}, _defineProperty({}, name, value));
    });
    setErrors(function (pre) {
      return _objectSpread(_objectSpread({}, pre), {}, _defineProperty({}, name, errors[name]));
    });
    setIsCorrect(function (pre) {
      return _objectSpread(_objectSpread({}, pre), {}, _defineProperty({}, name, !errors[name]));
    });
  };
  var handleBlur = function handleBlur(e) {
    var _e$target2 = e.target,
      name = _e$target2.name,
      value = _e$target2.value;
    var errors = validate(t)(null, name, value);
    if (Object.keys(errors).length) {
      setErrors(function (pre) {
        return _objectSpread(_objectSpread({}, pre), errors);
      });
    }
  };
  var handleSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
      var errors, formData, validationException, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            e.preventDefault();
            errors = validate(t)(values, null, null);
            if (!Object.keys(errors).length) {
              _context.n = 1;
              break;
            }
            setErrors(_objectSpread({}, errors));
            _context.n = 6;
            break;
          case 1:
            formData = new FormData();
            formData.append("name", values.name);
            formData.append("email", values.email);
            formData.append("body", values.body);
            formData.append("subject", values.subject);
            formData.append("phone", values.phone);
            _context.p = 2;
            _context.n = 3;
            return api__contactUsSubmit(formData);
          case 3:
            setMsPopUp(true);
            setValues({
              name: "",
              phone: "",
              email: "",
              subject: "",
              body: ""
            });
            setIsCorrect({
              name: false,
              phone: false,
              email: false,
              subject: false,
              body: false
            });
            onPushDataLayerNew("syarah_events", "form_sumitted", "contactUs");
            return _context.a(2, true);
          case 4:
            _context.p = 4;
            _t = _context.v;
            if (!(_t instanceof ValidationException)) {
              _context.n = 5;
              break;
            }
            validationException = _t;
            return _context.a(2, toast.error(validationException.getAllErrorMessages()));
          case 5:
            return _context.a(2, toast.error(_t.message));
          case 6:
            return _context.a(2, false);
        }
      }, _callee, null, [[2, 4]]);
    }));
    return function handleSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("form", {
    className: stl.contactForm,
    onSubmit: handleSubmit,
    autoComplete: "off"
  }, /*#__PURE__*/React.createElement("h1", {
    className: stl.formTitle
  }, t("تواصل معنا", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("div", {
    className: [stl.formGroup, errors.name ? stl.error : "", isCorrect.name ? stl.correct : ""].join(" ")
  }, /*#__PURE__*/React.createElement("label", null, t("الاسم بالكامل", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("input", {
    type: "text",
    placeholder: t("اسمك بالكامل", {
      ns: "web_common"
    }),
    name: "name",
    value: values.name,
    onBlur: handleBlur,
    onChange: handleChange
  }), errors.name && /*#__PURE__*/React.createElement("p", {
    className: stl.errorMessage
  }, errors.name)), /*#__PURE__*/React.createElement(InputPhoneNumber, {
    className: [stl.phoneInput, errors.phone ? stl.error : "", isCorrect.phone ? stl.correct : ""].join(" "),
    defaultValue: values.phone,
    onChange: function onChange(value) {
      // Manually create a synthetic event to pass to handleChange
      var syntheticEvent = {
        target: {
          name: "phone",
          // The name of the field
          value: value // The updated value from InputPhoneNumber
        }
      };
      handleChange(syntheticEvent);
    },
    errorLabel: errors.phone ? errors.phone : "",
    onFocus: function onFocus() {
      var _errors;
      ((_errors = errors) === null || _errors === void 0 ? void 0 : _errors.phone) && setErrors({
        errors: errors
      });
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: [stl.formGroup, errors.email ? stl.error : "", isCorrect.email ? stl.correct : ""].join(" ")
  }, /*#__PURE__*/React.createElement("label", null, t("البريد الإلكتروني", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("input", {
    type: "email",
    placeholder: "mail@example.com",
    name: "email",
    value: values.email,
    onChange: handleChange,
    onBlur: handleBlur
  }), errors.email && /*#__PURE__*/React.createElement("p", {
    className: stl.errorMessage
  }, errors.email)), /*#__PURE__*/React.createElement("div", {
    className: [stl.formGroup, errors.subject ? stl.error : "", isCorrect.subject ? stl.correct : ""].join(" ")
  }, /*#__PURE__*/React.createElement("label", null, t("عنوان الرسالة", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("input", {
    type: "text",
    placeholder: t("عنوان رسالتك", {
      ns: "web_common"
    }),
    name: "subject",
    value: values.subject,
    maxLength: 40,
    onBlur: handleBlur,
    onChange: handleChange
  }), errors.subject && /*#__PURE__*/React.createElement("p", {
    className: stl.errorMessage
  }, errors.subject)), /*#__PURE__*/React.createElement("div", {
    className: [stl.formGroup, errors.body ? stl.error : "", isCorrect.body ? stl.correct : ""].join(" ")
  }, /*#__PURE__*/React.createElement("label", null, t("الرسالة", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("textarea", {
    placeholder: t("ابدأ الكتابة", {
      ns: "web_common"
    }),
    name: "body",
    value: values.body,
    onChange: handleChange,
    onBlur: handleBlur
  }), errors.body && /*#__PURE__*/React.createElement("p", {
    className: stl.errorMessage
  }, errors.body)), /*#__PURE__*/React.createElement("button", {
    type: "submit",
    disabled: buttonLoading
  }, !buttonLoading && t("إرسال", {
    ns: "web_common"
  }), buttonLoading && t("يجري الإرسال", {
    ns: "web_common"
  }))), /*#__PURE__*/React.createElement(SharedPopUp, {
    show: msPopUp,
    onClose: function onClose() {
      return setMsPopUp(false);
    },
    oowh: true
  }, /*#__PURE__*/React.createElement("div", {
    className: [stl.popUpContainer, 'container'].join(' ')
  }, /*#__PURE__*/React.createElement("img", {
    width: "80",
    src: CDN_LINK + "/assets/images/greenTic.svg",
    alt: "done"
  }), /*#__PURE__*/React.createElement("strong", null, t("تم إرسال رسالتك بنجاح", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("p", null, t("سيتم التواصل معك في أقرب وقت", {
    ns: "web_common"
  })), /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      setMsPopUp(false);
      document.body.style.overflow = "";
    },
    className: "blueBtn"
  }, t("إغلاق", {
    ns: "web_common"
  })))));
};
export default ContactForm;